import React from 'react';
import CloudIcon from '@mui/icons-material/Cloud';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import BarChartIcon from '@mui/icons-material/BarChart';
import BuildIcon from '@mui/icons-material/Build';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { STSNavItem } from './STSNavItem';
import { NavDivider } from './NavDivider';

interface STSNavProps {
  infrastructureExpanded: boolean;
  operationsExpanded: boolean;
  isInfrastructureActive: boolean;
  isOperationsActive: boolean;
  setInfrastructureExpanded: (value: boolean) => void;
  setOperationsExpanded: (value: boolean) => void;
}

export const STSNav = ({
  infrastructureExpanded,
  operationsExpanded,
  isInfrastructureActive,
  isOperationsActive,
  setInfrastructureExpanded,
  setOperationsExpanded,
}: STSNavProps) => {
  return (
    <>
      <STSNavItem
        icon={BarChartIcon}
        text="Insights"
        to="sts/infrastructure-stats"
      />
      <NavDivider color="#e0e0e0" />
      <STSNavItem
        icon={DesktopWindowsIcon}
        text="Task Dashboard"
        to="sts/task-dashboard"
      />
      <NavDivider color="#e0e0e0" />
      <STSNavItem
        icon={AutorenewIcon}
        text="Lifecycle Management"
        to="sts/lifecycle-management"
      />
      <NavDivider color="#e0e0e0" />
      <STSNavItem
        icon={CloudIcon}
        text="Infra Provisioning"
        expandable
        isExpanded={infrastructureExpanded}
        onToggle={() => {
          if (!infrastructureExpanded) {
            setInfrastructureExpanded(true);
          } else if (!isInfrastructureActive) {
            setInfrastructureExpanded(false);
          }
        }}
      >
          <STSNavItem
        icon={AssignmentIcon}
        text="Requirement Agent"
        to="sts/requirement-agent"
      />
        <STSNavItem text="AWS" to="sts/infra-provisioning/aws" isSubItem />
        <STSNavItem text="Azure" to="sts/infra-provisioning/azure" isSubItem />
        <STSNavItem text="GCP" to="sts/infra-provisioning/gcp" isSubItem />
        <STSNavItem text="On-Premises" to="sts/infra-provisioning/on-premises" isSubItem />
      </STSNavItem>
      <NavDivider color="#e0e0e0" />
      <STSNavItem
        icon={BuildIcon}
        text="Infra Operations & Maintenance"
        expandable
        isExpanded={operationsExpanded}
        onToggle={() => {
          if (!operationsExpanded) {
            setOperationsExpanded(true);
          } else if (!isOperationsActive) {
            setOperationsExpanded(false);
          }
        }}
      >
        <STSNavItem text="Patch Management" to="sts/operations/patch-management" isSubItem />
        <STSNavItem text="Change Management" to="sts/operations/change-management" isSubItem />
        <STSNavItem text="Linux" to="sts/operations/linux" isSubItem />
        <STSNavItem text="Windows" to="sts/operations/windows" isSubItem />
        <STSNavItem text="Executions" to="sts/executions" isSubItem />
      </STSNavItem>
      <NavDivider color="#e0e0e0" />
      <STSNavItem
        icon={PlayArrowIcon}
        text="Playground"
        to="sts/playground"
      />
      <NavDivider color="#e0e0e0" />
    </>
  );
};
